export default function LoadingReducer(loading, action) {
    //console.log("loading", loading);
    //console.log("action", action);
    switch (action.type) {
        case "update": {
            //console.log("update ok!", action);
            return { progress: action.payload };
        }
        default: return loading;
    }
}